import type zh from '../zh/skills';

/**
 * Frozen copy of the skills text the UI showed before the zh/en switch, rendered while
 * UI_I18N_ENABLED is off (gamma / prod). Do not edit the text; add a key here only when
 * zh gains one, with the text the UI would show without the switch. Delete with the flag.
 */
const skills: typeof zh = {
  hero: {
    title: "Rocky's Armory",
    count: '<highlight>{{n}} Skills</highlight> are now available!',
    imageAlt: "Rocky's Armory characters",
  },
  tabs: {
    recommend: 'Recommend',
    mySkills: 'My Skills',
  },
  categories: {
    dataretriever: 'Retrieve and aggregate data from multiple sources.',
    hedwig: 'Automate messaging workflows and notification delivery.',
    cheetah:
      'Internal expert booking service — match the right person to your needs, one-click booking and track the entire engagement workflow.',
    ivt: 'Industry vertical solutions — explore solution maps, storylines, assets and motions to power vertical selling.',
    campaign_copilot: 'Campaign orchestration — audience segmentation, personalized emails, Octopus program creation and performance analytics.',
    event_insights: 'Event insights — pre- and post-event data reports.',
  },
  search: 'Find skill',
  loading: 'Loading skills...',
  loadFailed: 'Failed to load skills: {{message}}',
  empty: 'No skills found.',
  untitled: 'Untitled',
  generalTag: 'General',
  card: {
    showDetails: 'Show Details',
  },
  modal: {
    close: 'Close',
    noDescription: 'No description available.',
    noPreview: 'Preview not available',
    cancel: 'Cancel',
    processing: 'Processing...',
    equip: 'Equip Skill',
    unequip: 'Unequip Skill',
  },
  cheetah: {
    back: '返回 Workspace',
    introLabel: 'Cheetah introduction',
    intro: '想带技术大佬一起拜访客户？Cheetah 为您提供标准化的专家预约服务，您可以按需求匹配资源、在线完成预约、跟进拜访流程。',
    revisit: '预约回访',
    book: '一键预约',
    revisitPrompt: '我想安排一次回访。',
    bookPrompt: '我想预约一位技术专家拜访客户。',
    expertsLabel: 'Tech experts',
    expertTitle: 'External Title: {{title}}',
    phoneTool: '{{name}} PhoneTool',
    modalTitle: 'Expert Information',
    modalLabel: 'Expert Information',
    close: '关闭',
  },
};

export default skills;
